<template>
  <Modal class="modal-activity" :value="value" :mask-closable="false" width="500" @on-cancel="cancel">
    <div slot="header" style="text-align: center">
      <span>{{ title }}</span>
    </div>
    <div>
    <Form 
      :label-width="150"
      label-position="right"
      style="margin-left: -40px;margin-right: 40px">
        <FormItem required label="执行情况" style="margin-bottom: 16px">
          <Select v-model="cur.is_execute">
            <Option :value="1" key="1">已执行</Option>
            <Option :value="0" key="0">未执行</Option>
          </Select>
        </FormItem>
        <template v-if="dataSource.type === 'medicine' && cur.is_execute === 1">
          <FormItem v-for="(m, mIndex) in dataSource.list" :key="mIndex" :label="m.medicine_name + '剂量'" required>
            <InputNumber
              v-model="cur.dosages[mIndex]"
              :precision="2"
              :min="0"
              :activeChange="false"
              placeholder="请填写实际剂量"
              style="width: 100%"
            />
          <span style="font-size: 14px">计划: {{m.usage}} <span style="color:#ff9e00;"> {{m.dosage}} </span> {{m.unit}}</span>
          </FormItem>
        </template>
        <FormItem v-if="cur.is_execute === 1" required label="执行时间">
          <DatePicker style="width: 100%" v-model="cur.date" type="datetime" format="yyyy-MM-dd HH:mm"></DatePicker>
          <span style="font-size: 14px ">计划时间为: <span style="color:#ff9e00;">{{time_placeholder}}</span></span>
        </FormItem>
        <FormItem v-if="cur.is_execute === 0" required label="原因">
          <Select v-model="cur.result">
            <Option value="主动停用" key="主动停用">主动停用</Option>
            <Option value="医嘱停用" key="医嘱停用">医嘱停用</Option>
          </Select>
        </FormItem>
        <!-- <FormItem v-if="show_remark && cur.is_execute === 1" required label="备注">
          <Input
            v-model="cur.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请填写备注"
          ></Input>
        </FormItem> -->
        <FormItem v-if="cur.is_execute === 0" label="备注">
          <Input
            v-model="cur.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请填写备注"
          ></Input>
        </FormItem>
      </Form>
    </div>
    <div slot="footer" style="text-align: center">
      <el-button type="info" round @click="cancel">取消</el-button>
      <el-button type="primary" round :loading="modalLoading" @click="save">保存</el-button>
    </div>
  </Modal>
</template>
<script>
import { formatDate } from '../../../utils/date';
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: ""
    },
    dataSource: {
      type: Object,
      default: () => ({})
    },
    modalLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cur: {},
      extra: {}
    };
  },
  computed: {
    time_placeholder() {
      if (this.dataSource && this.dataSource) {
        return formatDate(new Date(this.dataSource.start_time), null, 'yyyy-MM-dd HH:mm');
      }
      return '';
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.cur = {
          date: this.dataSource.execute_time ? new Date(this.dataSource.execute_time) : new Date(),
          is_execute: this.dataSource.is_execute !== null ? this.dataSource.is_execute : 1,
          result: this.dataSource.result || '主动停用',
          remark: this.dataSource.remark || ''
        }
        if (this.dataSource.type === 'medicine') {
          this.cur.dosages = this.dataSource.list.map(l => l.extra.dosage - 0);
        }
      } else {
        this.cur = {}
      }
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    save() {
      if (this.dataSource.type === 'medicine' && this.cur.is_execute === 1) {
        if (this.cur.dosages.filter((d, i) => (d - 0) !== (this.dataSource.list[i].dosage - 0)).length) {
          this.cur.remark = '未按计划剂量用药';
        } else {
          this.cur.remark = '';
        }
      }
      this.$emit('save', this.cur, this.dataSource);
    }
  },
};
</script>
<style lang="less">
.modal-activity{
  .ivu-form-item{
    margin-bottom: 12px;
  }
}
</style>
